<template>
  <div
    class="m-pc-thumbs"
    :class="{ 'is-thumbs': !canLike }"
    v-if="isAllowedLike"
    @click="like()"
  >
    <span class="icontemp dianzan"></span>
    <span class="num">{{ likeCount }}</span>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import { articleId } from "../common/sbase";

import service from "../services/article";
export default {
  name: "Thumbs",
  data() {
    return {
      isAllowedLike: true,
      likeCount: 0,
      canLike: true,
      schemaId: "",
      isSubmitting: false,
      userInfo: {}
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.isAllowedLike = info.isAllowedLike == 1;
        this.likeCount = info.likeCount;
        this.schemaId = info.schemaId;
        if (this.isAllowedLike) {
          this.getLikeStatus(info);
        }
      }
    });
    $subscriber.subscribe("user-info", info => {
      if (info) {
        this.userInfo = info;
      }
    });
  },
  methods: {
    like() {
      if (!this.canLike || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      let param = {
        articleId: articleId,
        globalUserId: this.userInfo.globalUserId,
        openId: this.userInfo.openId || "",
        sess: this.userInfo.session || "",
        weChatId: "",
        resolution: window.screen.width + "*" + window.screen.height
      };
      service.like(param).subscribe(data => {
        if (data.result == 0) {
          this.likeCount = parseInt(this.likeCount) + 1;
          $subscriber.emit("like-count", this.likeCount);
          this.canLike = false;
        }
        setTimeout(() => {
          this.isSubmitting = false;
        }, 500);
      });
    },
    getLikeStatus() {
      let self = this;
      let param = {
        articleId: articleId,
        globalUserId: this.userInfo.globalUserId,
        openId: this.userInfo.openId || "",
        sess: this.userInfo.sess || ""
      };
      service.getLikeStatus(param).subscribe(data => {
        self.canLike = Number(data.content.canLike) === 1;
      });
    }
  },
  components: {}
};
</script>
